import type { DeleteIndicatorResultsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteIndicatorResultsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteIndicatorResults = createMutationHook({
  name: 'deleteIndicatorResults',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.indicator.deleteResults.mutationOptions({ onSuccess }),
  mapInput: (variables: { ids: string[] }) => ({ ids: variables.ids }),
  invalidate: (trpc) => [
    trpc.frontend.indicator.indicatorResultsByIndicatorId.queryKey(),
    trpc.frontend.indicator.indicatorById.queryKey(),
    // COI-889: the indicator register and the risk/control Indicators tabs
    // read latest/previous result and conformance off this router.
    trpc.frontend.indicator.pathKey(),
  ],
  mapResponse: (
    _result,
    variables: { ids: string[] }
  ): DeleteIndicatorResultsMutation => ({
    delete_indicator_result: {
      __typename: 'indicator_result_mutation_response',
      affected_rows: variables.ids.length,
    },
  }),
  graphqlDocument: DeleteIndicatorResultsDocument,
  graphqlVariables: (variables: { ids: string[] }) => ({
    ids: variables.ids,
  }),
  evictFields: ['indicator_result', 'indicator'],
});
